import React, { useState, useEffect } from 'react';
import HsForms from "./hs-forms";

const Calculator = ({ 
  initialValue = 50000,
  minValue = 1000,
  maxValue = 300000,
  step = 1000,
  multiplier = 1.75 * 2.08 * 12,
  buttonText = "Get Quote",
  formId = null,
  showForm: externalShowForm = null,
  onFormToggle = null,
  className = ""
}) => {
  const [member, setMember] = useState(initialValue);
  const [form, showForm] = useState(false);

  // Use external form state if provided
  const isFormVisible = externalShowForm !== null ? externalShowForm : form;
  const toggleFormState = externalShowForm !== null ? onFormToggle : showForm;

  let quote = ~~(member * multiplier);
  let finalMember = member * 1;

  const handleChange = e => {
    setMember(e.target.value);
    
    const value = e.target.value;

    // Push an event to the dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "rangeInputEngagement",
      rangeValue: value,
    });
  };

  const handleRangeChange = (event) => {
    const value = event.target.value;

    // Push an event to the dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "rangeInputEngagement",
      rangeValue: value,
    });
  };

  const formattedQuote = quote.toLocaleString();
  const formattedMember = finalMember.toLocaleString();
  
  useEffect(() => {
    const slider = document.querySelector(".range");
    if (!slider) return;

    const adjustSlider = () => {
      const min = slider.min;
      const max = slider.max;
      const val = ((slider.value - min) * 100) / (max - min);
      
      const fillLeft = "#84bd00";
      const fillRight = "#ccc";
      
      slider.style.background = `linear-gradient(to right, ${fillLeft} ${val}%, ${fillRight} ${val}%`;
    };

    slider.addEventListener("input", adjustSlider);
    adjustSlider();

    return () => {
      slider.removeEventListener("input", adjustSlider);
    };
  }, []);

  const toggleForm = () => {
    if (toggleFormState) {
      toggleFormState(true);
    }
  };

  const hideForm = () => {
    if (toggleFormState) {
      toggleFormState(false);
    }
  };

  return (
    <div className={`calculator rounded-2xl shadow-2xl pt-10 px-12 bg-white ${className}`}>
      <div className="text-center mb-6">
        <div className="text-5xl font-bold mb-1">${formattedQuote}</div>
        <span>annual pharmacy cost savings</span>
      </div>
      <input 
        className="range" 
        type="range" 
        value={member} 
        min={minValue} 
        max={maxValue} 
        step={step} 
        onChange={handleChange} 
        onMouseUp={handleRangeChange} 
      />
      <div className="text-center mt-6">
        <div className="text-3xl font-bold text-green">{formattedMember}</div>
        <span>employees</span>
      </div>
      <div className="flex justify-center">
        {!isFormVisible && (
          <a 
            onClick={toggleForm} 
            className="btn bg-yellow text-lg pr-8 pl-5 relative -bottom-6 border-4 border-white shadow-lg"
          >
            {buttonText}
          </a>
        )}
      </div>
      {isFormVisible && formId && (
        <div className="pb-2 pt-6">
          <HsForms formId={formId} />
          <div className="flex justify-center">
            <a 
              onClick={hideForm} 
              className="btn-nocarat bg-grey-light !text-grey relative -bottom-7 border-4 border-white shadow-lg !no-underline"
            >
              Hide form
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Calculator;
